document.addEventListener("DOMContentLoaded", () => {
    let productGalleries = [];
    let productGalleriesThumbnails = [];
    document.querySelectorAll('.product-gallery__main').forEach(function (element, elementIndex) {
      const productGallery = new Flickity(element, {
        wrapAround: true,
        adaptiveHeight: true,
        dragThreshold: 10,
        imagesLoaded: true,
        pageDots: false,
        prevNextButtons: true,
        autoPlay: false,
        fade: true,
        arrowShape: window.arrowShape,
      });
      productGalleries[elementIndex] = productGallery;
    });
    
    document.querySelectorAll('.product-gallery__thumbnails').forEach(function (element, elementIndex) {
      const productGalleryThumbnail = new Flickity(element, {
        cellAlign: 'center',
        contain: true,
        groupCells: '80%',
        imagesLoaded: true,
        pageDots: false,
        prevNextButtons: false,
        arrowShape: window.arrowShape,
      });
      productGalleryThumbnail.on( 'staticClick', function( event, pointer, cellElem, cellIndex ) {
        if ( cellIndex !== undefined ) {
          if(productGalleryThumbnail.element?.querySelector('.is-nav-selected')) {
            productGalleryThumbnail.element?.querySelector('.is-nav-selected')?.classList.remove('is-nav-selected');
          }
          cellElem.classList.add('is-nav-selected');
          productGalleries[elementIndex].selectCell(cellIndex);
        }
      });
      productGalleriesThumbnails[elementIndex] = productGalleryThumbnail;
    });
  });